var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._t("default",null,{"hasItems":_vm.hasItems,"items":_vm.items,"activeItem":_vm.activeItem,"extraFields":_vm.extraFields,"enter":_vm.enter,"clear":_vm.clear,"moveUp":_vm.moveUp,"moveDown":_vm.moveDown,"fields":_vm.fields})
}
var staticRenderFns = []

export { render, staticRenderFns }